/**
 * whatsapp.ts · W128.6 · 2026-05-26.
 *
 * Helper para montar links wa.me a partir de um telefone (qualquer
 * formato) + mensagem pré-preenchida opcional, espelha o utilitário
 * de apps/web/src/lib/whatsapp-deeplink.ts mas vive standalone aqui
 * porque o casa é bundle isolado (sem cross-import com web).
 *
 * Quando o telefone não está disponível (null/undefined/vazio), faz
 * fallback pro mailto de suporte — comprador nunca fica sem CTA.
 */

export const SUPPORT_EMAIL = 'contato@nullscience.ai';

/**
 * Builds a WhatsApp deeplink (`https://wa.me/<digits>?text=<encoded>`).
 *
 * @param phone           Owner-facing PM/builder phone. Any format.
 * @param prefilledMessage Optional initial message text. URL-encoded.
 * @returns                wa.me URL when phone is present, otherwise `mailto:`.
 */
export function whatsappDeeplink(
  phone?: string | null,
  prefilledMessage?: string,
): string {
  if (!phone) {
    const subject = prefilledMessage
      ? `?subject=${encodeURIComponent(prefilledMessage)}`
      : '';
    return `mailto:${SUPPORT_EMAIL}${subject}`;
  }
  const clean = phone.replace(/\D/g, '');
  if (!clean) {
    return `mailto:${SUPPORT_EMAIL}`;
  }
  const url = `https://wa.me/${clean}`;
  if (prefilledMessage && prefilledMessage.trim().length > 0) {
    return `${url}?text=${encodeURIComponent(prefilledMessage)}`;
  }
  return url;
}

/**
 * Resolve WhatsApp number from build env. Single-tenant prod hoje:
 * Nullscience usa o número do JP. Vite injeta `VITE_BUILDER_WHATSAPP`
 * no bundle em build-time. Se faltar, helper acima cai no mailto.
 */
export function builderWhatsappFromEnv(): string | null {
  const v = (import.meta as unknown as {
    env?: { VITE_BUILDER_WHATSAPP?: string };
  }).env?.VITE_BUILDER_WHATSAPP;
  const trimmed = typeof v === 'string' ? v.trim() : '';
  return trimmed.length > 0 ? trimmed : null;
}
